/**
 * permissions service
 */

import Resource from './resource'

export default new Resource('permissions')



// WEBPACK FOOTER //
// ./src/libraries/services/permissions.js